<template>
  <v-card
      v-if="content && IndexGroup"
  >
    <v-card-title>
      <span
          class="text-truncate"
          style="max-width: 900px"
      >
        {{ IndexGroup.title }}
      </span>

      <v-spacer/>

      <v-btn
          :icon="true"
          :outlined="true"
          color="primary"
          to="/index-groups"
      >
        <v-icon>
          mdi-reply
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col
            cols="12"
        >
          <Indexes
              :IndexGroup="IndexGroup"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>

  <v-progress-circular
      v-else
      :indeterminate="true"
  />
</template>

<script>
  import IndexGroups from '@/services/index-groups'

  import Indexes from '@/components/IndexGroup/Indexes'

  export default {
    name: 'IndexGroup',
    components: {
      Indexes
    },
    data() {
      return {
        content: false,
        loading: false,
        IndexGroup: null
      }
    },
    metaInfo() {
      return {
        title: (
          this.IndexGroup
            ? this.IndexGroup.title
            : ''
        )
      }
    },
    mounted() {
      this.init()
    },
    watch: {
      $route(to, from) {
        if (to.path !== from.path) {
          this.init()
        }
      }
    },
    methods: {
      init() {
        this.loadData()
      },
      refresh() {
        this.loadData('loading', true)
      },
      setBreadcrumbs() {
        this.$store.dispatch('layout/setBreadcrumbs', {
          breadcrumbs: [
            {
              text: 'Skupiny číselníkov',
              to: '/index-groups'
            }
          ]
        })
      },
      loadData(key = 'content', value = false) {
        this[key] = value

        IndexGroups
          .read({
            id: this.$route.params.id
          })
          .then((response) => {
            this.setBreadcrumbs()

            this.$store.dispatch('layout/addBreadcrumbs', {
              breadcrumbs: [
                {
                  text: response.data.data.IndexGroup.title,
                  to: '/index-group/' + response.data.data.IndexGroup.id
                }
              ]
            })

            this.IndexGroup = response.data.data.IndexGroup
          })
          .catch((error) => {
            switch (error.response.status) {
              case 401:
              case 404:
              case 500:
                this.$store.dispatch('layout/openSnackbar', {
                  message: error.response.data.message
                })

                this.$router.replace('/index-groups')

                break
            }
          })
          .finally(() => {
            this[key] = !value
          })
      }
    }
  }
</script>
